import {
    ADDORUPDATEROLE_SUCCESS,
    ADDORUPDATEROLE_FAILED,
    RESET_ADDORUPDATEROLE,
    LOADING_ADDORUPDATEROLE,
    NETWORK_ERROR_ADDORUPDATEROLE,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAddOrUpdateRole = () => {
    return { type: RESET_ADDORUPDATEROLE };
};

const addOrUpdateRole = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDORUPDATEROLE });
    await adminServices
        .post("addOrUpdateRole", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addOrUpdateRolesuccess(res.data));
                    break;
                default:
                    dispatch(addOrUpdateRoleFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_ADDORUPDATEROLE, payload: err });
        });
};
function addOrUpdateRolesuccess(data) {
    return {
        type: ADDORUPDATEROLE_SUCCESS,
        payload: data,
    };
}
function addOrUpdateRoleFailed(data) {
    return {
        type: ADDORUPDATEROLE_FAILED,
        payload: data,
    };
}

export { resetAddOrUpdateRole, addOrUpdateRole };
